import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDM } from '@/context/DMContext';

interface NotificationClickMessage {
  type: 'NOTIFICATION_CLICK';
  url: string;
  data?: {
    conversationId?: string;
    messageId?: string;
    senderId?: string;
  };
}

/**
 * Hook to handle navigation from push notification clicks.
 * Listens for messages from the service worker and navigates accordingly.
 */
export function useNotificationNavigation() {
  const navigate = useNavigate();
  const { openConversation } = useDM();

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const message = event.data as NotificationClickMessage;

      if (message?.type === 'NOTIFICATION_CLICK') {
        // If there's a conversation ID, open it
        if (message.data?.conversationId) {
          openConversation(message.data.conversationId);
        }

        // Navigate to the URL from the notification
        if (message.url) {
          // Handle relative URLs
          const url = message.url.startsWith('/') ? message.url : `/${message.url}`;
          navigate(url);
        }
      }
    };

    // Listen for messages from service worker
    navigator.serviceWorker?.addEventListener('message', handleMessage);

    return () => {
      navigator.serviceWorker?.removeEventListener('message', handleMessage);
    };
  }, [navigate, openConversation]);
}

export default useNotificationNavigation;
